// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".btnSignIn {\n  background-color: #d40000;\n  border: 1px solid #d40000;\n  border-radius: 5px;\n  padding: 10px 20px;\n  font-size: 16px;\n  color: #fff;\n}\n.btnSignIn:hover {\n  cursor: pointer;\n  color: #fff;\n  background-color: #ed0302;\n  border: 1px solid #ed0302;\n}\n.btnSignIn:active,\n.btnSignIn:focus {\n  background-color: #b90001;\n  border: 1px solid #b90001;\n}", ""]);
// Exports
module.exports = exports;
